import type { FC } from 'react';

import clsx from 'clsx';

import { NewsPage } from '@/lib/contentful/news';
import styles from './TagsFilter.module.scss';

interface TagsFilterProps {
  newsPagesCollection: Array<NewsPage | null>;
  onTagClick: (tag: string) => void;
  selectedTag?: string;
}

const TagsFilter: FC<TagsFilterProps> = ({ newsPagesCollection, onTagClick, selectedTag }) => {
  const tagsSet = new Set<string>();

  newsPagesCollection.forEach((item) => {
    item?.tagsCollection?.items.forEach((tag) => {
      if (tag?.value) {
        tagsSet.add(tag.value);
      }
    });
  });

  const tagsArray = Array.from(tagsSet);

  return (
    <div className={styles.tagsContainer}>
      {tagsArray.map((tag) => (
        <button
          key={tag}
          aria-pressed={selectedTag === tag}
          className={clsx(styles.tag, selectedTag === tag && styles.selected)}
          onClick={() => onTagClick(tag)}
        >
          {tag}
        </button>
      ))}
    </div>
  );
};

export default TagsFilter;
